// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ywJc","top":"styles_top__3IPs7","left":"styles_left__1NxIN","description":"styles_description__2BTWo"};